<div>
    <div class="header6 view-as-text" *ngIf="bac && bac.length > 0">Viewing report as: <span style="font-weight: bold;">{{dealerName}}</span> with BAC: <span style="font-weight: bold;">{{numericBAC}}</span></div>
    <div id="reportContainer" class="reportContainer"></div>
</div>